function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".hamburger_svg__st0{fill:#e23c3c}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "hamburger_svg__st0",
  d: "M75.48 17.39h155.04v12.22H75.48zM75.67 47.48h131.67v15.04H75.67zM75.48 83.57h155.04v17.86H75.48z"
});

function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hamburger_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 314 135",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzMTQgMTM1IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAzMTQgMTM1OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0UyM0MzQzt9Cjwvc3R5bGU+CjxyZWN0IHg9Ijc1LjQ4IiB5PSIxNy4zOSIgY2xhc3M9InN0MCIgd2lkdGg9IjE1NS4wNCIgaGVpZ2h0PSIxMi4yMiIvPgo8cmVjdCB4PSI3NS42NyIgeT0iNDcuNDgiIGNsYXNzPSJzdDAiIHdpZHRoPSIxMzEuNjciIGhlaWdodD0iMTUuMDQiLz4KPHJlY3QgeD0iNzUuNDgiIHk9IjgzLjU3IiBjbGFzcz0ic3QwIiB3aWR0aD0iMTU1LjA0IiBoZWlnaHQ9IjE3Ljg2Ii8+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
export { SvgHamburger as ReactComponent };